module.exports = __webpack_public_path__ + "static/img/9.6680297.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/sp/9.png
// module id = yz/e
// module chunks = 0